// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../bundler/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../bundler/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ql-textInputContainer {
    padding-right: 0px !important;
    padding-bottom: 0px !important;
    width: 100% !important;
    font-family: Roboto-Regular !important;
}

.ql-textInputContainer > .ql-editor {
    overflow: hidden;
}

.ql-textInputContainer > .ql-editor > p {
    line-height: 34px;
}

.ql-textInputContainer > .ql-editor > p::content {
    position: relative;
    bottom: 0;
}

.ql-textInputContainer > .ql-editor .ql-url,
.ql-textInputContainer > .ql-editor .ql-email,
.ql-textInputContainer > .ql-editor .ql-hashtag {
    position: relative;
    top: 2px;
}

.ql-textInputContainer > .ql-editor .ql-mention {
    position: relative;
    top: 2.7px;
}

.ql-textInputContainer > .ql-editor .ql-mention[userid='0'] {
    position: relative;
    top: 2px;
}

.ql-textInputContainer > .ql-editor .ql-url div > span:first-of-type,
.ql-textInputContainer > .ql-editor .ql-email div > span:first-of-type,
.ql-textInputContainer > .ql-editor .ql-hashtag div > span:first-of-type,
.ql-textInputContainer > .ql-editor .ql-mention div > span:first-of-type {
    margin-top: 0;
}

.ql-textInputContainer > .ql-editor.ql-blank::before {
    top: 5px;
    left: 0 !important;
    right: 15px !important;
    color: #8a94a6 !important;
    font-style: normal !important;
    font-weight: normal !important;
    line-height: 24px !important;
    letter-spacing: 0.02em !important;
}

.ql-taskTextInputContainer > .ql-editor.ql-blank::before {
    font-size: 16px !important;
}

.ql-subtaskTextInputContainer > .ql-editor.ql-blank::before {
    font-size: 14px !important;
}

.ql-textInputEditor {
    height: 100%;
    width: 100%;
    overflow: auto;
    margin-top: 0px !important;
    padding: 0px !important;
    line-height: 24px !important;
}

/* Reserves the dictation mic overlay's strip (right: 8 + 24px button + gap) so text wraps before
   it instead of flowing beneath. Applied whenever dictation is enabled on the input — not only
   while the mic is visible — so focusing/hovering never reflows the text. Must stay AFTER
   .ql-textInputEditor: both are single-class selectors, so source order decides which
   !important padding wins. */
.ql-editorWithDictation {
    padding-right: 34px !important;
}

/* The assistant composer pins the chat attachment menu beside the mic. Keep both controls
   outside the scroll content and reserve their width, including on narrow screens. */
.ql-editorWithAttachment {
    padding-right: 34px !important;
}

.ql-editorWithAttachmentAndDictation {
    padding-right: 62px !important;
}

.ql-clipboard {
    -webkit-user-select: text;
}

.ql-textInputEditorSingleLine {
    overflow-x: visible !important;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
}

.ql-textInputEditorSingleLine > p {
    white-space: pre !important;
}

.ql-textInputEditorSingleLine::-webkit-scrollbar {
    display: none; /* Hide scrollbar for Chrome, Safari and Opera */
}

body::-webkit-scrollbar {
    display: none; /* Hide scrollbar for Chrome, Safari and Opera */
}

body {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
}

.ql-taskTextInputEditor {
    font-size: 16px !important;
}

.ql-goalTextInputEditor {
    color: #04142f !important;
}

.ql-subtaskTextInputEditor {
    font-size: 14px !important;
    letter-spacing: 0.02em !important;
    color: #04142f !important;
    word-spacing: 0.05em !important;
}

.ql-modalTextInputEditor {
    color: #ffffff !important;
    caret-color: #ffffff !important;
}

.ql-modalTextInputEditorModern {
    color: #007FFF !important;
    caret-color: #007FFF !important;
}

.ql-newTopicModalTextInputEditor {
    min-height: 80px !important;
}

.ql-createTaskModalTextInputEditor {
    min-height: 38px !important;
}

.ql-createSubtaskModalTextInputContainer > .ql-editor.ql-blank::before {
    font-size: 14px !important;
    margin-top: 0.5px !important;
    letter-spacing: 0.255px !important;
    word-spacing: 0.03em !important;
}

.ql-createSubtaskModalTextInputEditor {
    min-height: 38px !important;
    font-size: 14px !important;
    letter-spacing: 0.02em !important;
    color: #ffffff !important;
    word-spacing: 0.05em !important;
    margin-top: 1px !important;
}

.ql-createDefaultProjectTextInputContainer > .ql-editor.ql-blank::before {
    color: #6c8fc9 !important;
}

.ql-createModernProjectTextInputContainer > .ql-editor.ql-blank::before {
    color: #B7BDC8 !important;
}

.ql-inviteDefaultTextInputContainer > .ql-editor.ql-blank::before {
    color: #ffffff !important;
    font-size: 14px !important;
    letter-spacing: 0.023em !important;
}

.ql-inviteModernTextInputEditor > .ql-editor.ql-blank::before {
    color: #4E5D78 !important;
    font-size: 14px !important;
    letter-spacing: 0.023em !important;
}

.ql-inviteDefaultTextInputEditor {
    color: #ffffff;
    font-size: 14px !important;
    letter-spacing: 0.023em !important;
}

.ql-inviteModernTextInputEditor {
    color: #4E5D78;
    font-size: 14px !important;
    letter-spacing: 0.023em !important;
}

.ql-searchTextInputContainer > .ql-editor.ql-blank::before {
    top: 4.5px !important;
    color: #c6cdd2 !important;
}

@media only screen and (min-width: 1098px) {
    .ql-textInputContainer > .ql-editor.ql-blank::before {
        padding-left: 0;
    }
}
@media only screen and (max-width: 1328px) {
    .ql-textInputContainer > .ql-editor.ql-blank::before {
        padding-left: 0;
    }
}
@media only screen and (max-width: 819px) {
    .ql-textInputContainer > .ql-editor.ql-blank::before {
        left: -18px;
    }
}
`, "",{"version":3,"sources":["webpack://./components/Feeds/CommentsTextInput/styles.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;;;IAGI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;;;;IAII,aAAa;AACjB;;AAEA;IACI,QAAQ;IACR,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;IAC7B,8BAA8B;IAC9B,4BAA4B;IAC5B,iCAAiC;AACrC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;IACd,0BAA0B;IAC1B,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;;;;6BAI6B;AAC7B;IACI,8BAA8B;AAClC;;AAEA;qFACqF;AACrF;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,wBAAwB,EAAE,gBAAgB;IAC1C,qBAAqB,EAAE,YAAY;AACvC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa,EAAE,gDAAgD;AACnE;;AAEA;IACI,aAAa,EAAE,gDAAgD;AACnE;;AAEA;IACI,wBAAwB,EAAE,gBAAgB;IAC1C,qBAAqB,EAAE,YAAY;AACvC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,iCAAiC;IACjC,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,kCAAkC;IAClC,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,iCAAiC;IACjC,yBAAyB;IACzB,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":[".ql-textInputContainer {\n    padding-right: 0px !important;\n    padding-bottom: 0px !important;\n    width: 100% !important;\n    font-family: Roboto-Regular !important;\n}\n\n.ql-textInputContainer > .ql-editor {\n    overflow: hidden;\n}\n\n.ql-textInputContainer > .ql-editor > p {\n    line-height: 34px;\n}\n\n.ql-textInputContainer > .ql-editor > p::content {\n    position: relative;\n    bottom: 0;\n}\n\n.ql-textInputContainer > .ql-editor .ql-url,\n.ql-textInputContainer > .ql-editor .ql-email,\n.ql-textInputContainer > .ql-editor .ql-hashtag {\n    position: relative;\n    top: 2px;\n}\n\n.ql-textInputContainer > .ql-editor .ql-mention {\n    position: relative;\n    top: 2.7px;\n}\n\n.ql-textInputContainer > .ql-editor .ql-mention[userid='0'] {\n    position: relative;\n    top: 2px;\n}\n\n.ql-textInputContainer > .ql-editor .ql-url div > span:first-of-type,\n.ql-textInputContainer > .ql-editor .ql-email div > span:first-of-type,\n.ql-textInputContainer > .ql-editor .ql-hashtag div > span:first-of-type,\n.ql-textInputContainer > .ql-editor .ql-mention div > span:first-of-type {\n    margin-top: 0;\n}\n\n.ql-textInputContainer > .ql-editor.ql-blank::before {\n    top: 5px;\n    left: 0 !important;\n    right: 15px !important;\n    color: #8a94a6 !important;\n    font-style: normal !important;\n    font-weight: normal !important;\n    line-height: 24px !important;\n    letter-spacing: 0.02em !important;\n}\n\n.ql-taskTextInputContainer > .ql-editor.ql-blank::before {\n    font-size: 16px !important;\n}\n\n.ql-subtaskTextInputContainer > .ql-editor.ql-blank::before {\n    font-size: 14px !important;\n}\n\n.ql-textInputEditor {\n    height: 100%;\n    width: 100%;\n    overflow: auto;\n    margin-top: 0px !important;\n    padding: 0px !important;\n    line-height: 24px !important;\n}\n\n/* Reserves the dictation mic overlay's strip (right: 8 + 24px button + gap) so text wraps before\n   it instead of flowing beneath. Applied whenever dictation is enabled on the input — not only\n   while the mic is visible — so focusing/hovering never reflows the text. Must stay AFTER\n   .ql-textInputEditor: both are single-class selectors, so source order decides which\n   !important padding wins. */\n.ql-editorWithDictation {\n    padding-right: 34px !important;\n}\n\n/* The assistant composer pins the chat attachment menu beside the mic. Keep both controls\n   outside the scroll content and reserve their width, including on narrow screens. */\n.ql-editorWithAttachment {\n    padding-right: 34px !important;\n}\n\n.ql-editorWithAttachmentAndDictation {\n    padding-right: 62px !important;\n}\n\n.ql-clipboard {\n    -webkit-user-select: text;\n}\n\n.ql-textInputEditorSingleLine {\n    overflow-x: visible !important;\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n}\n\n.ql-textInputEditorSingleLine > p {\n    white-space: pre !important;\n}\n\n.ql-textInputEditorSingleLine::-webkit-scrollbar {\n    display: none; /* Hide scrollbar for Chrome, Safari and Opera */\n}\n\nbody::-webkit-scrollbar {\n    display: none; /* Hide scrollbar for Chrome, Safari and Opera */\n}\n\nbody {\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n}\n\n.ql-taskTextInputEditor {\n    font-size: 16px !important;\n}\n\n.ql-goalTextInputEditor {\n    color: #04142f !important;\n}\n\n.ql-subtaskTextInputEditor {\n    font-size: 14px !important;\n    letter-spacing: 0.02em !important;\n    color: #04142f !important;\n    word-spacing: 0.05em !important;\n}\n\n.ql-modalTextInputEditor {\n    color: #ffffff !important;\n    caret-color: #ffffff !important;\n}\n\n.ql-modalTextInputEditorModern {\n    color: #007FFF !important;\n    caret-color: #007FFF !important;\n}\n\n.ql-newTopicModalTextInputEditor {\n    min-height: 80px !important;\n}\n\n.ql-createTaskModalTextInputEditor {\n    min-height: 38px !important;\n}\n\n.ql-createSubtaskModalTextInputContainer > .ql-editor.ql-blank::before {\n    font-size: 14px !important;\n    margin-top: 0.5px !important;\n    letter-spacing: 0.255px !important;\n    word-spacing: 0.03em !important;\n}\n\n.ql-createSubtaskModalTextInputEditor {\n    min-height: 38px !important;\n    font-size: 14px !important;\n    letter-spacing: 0.02em !important;\n    color: #ffffff !important;\n    word-spacing: 0.05em !important;\n    margin-top: 1px !important;\n}\n\n.ql-createDefaultProjectTextInputContainer > .ql-editor.ql-blank::before {\n    color: #6c8fc9 !important;\n}\n\n.ql-createModernProjectTextInputContainer > .ql-editor.ql-blank::before {\n    color: #B7BDC8 !important;\n}\n\n.ql-inviteDefaultTextInputContainer > .ql-editor.ql-blank::before {\n    color: #ffffff !important;\n    font-size: 14px !important;\n    letter-spacing: 0.023em !important;\n}\n\n.ql-inviteModernTextInputEditor > .ql-editor.ql-blank::before {\n    color: #4E5D78 !important;\n    font-size: 14px !important;\n    letter-spacing: 0.023em !important;\n}\n\n.ql-inviteDefaultTextInputEditor {\n    color: #ffffff;\n    font-size: 14px !important;\n    letter-spacing: 0.023em !important;\n}\n\n.ql-inviteModernTextInputEditor {\n    color: #4E5D78;\n    font-size: 14px !important;\n    letter-spacing: 0.023em !important;\n}\n\n.ql-searchTextInputContainer > .ql-editor.ql-blank::before {\n    top: 4.5px !important;\n    color: #c6cdd2 !important;\n}\n\n@media only screen and (min-width: 1098px) {\n    .ql-textInputContainer > .ql-editor.ql-blank::before {\n        padding-left: 0;\n    }\n}\n@media only screen and (max-width: 1328px) {\n    .ql-textInputContainer > .ql-editor.ql-blank::before {\n        padding-left: 0;\n    }\n}\n@media only screen and (max-width: 819px) {\n    .ql-textInputContainer > .ql-editor.ql-blank::before {\n        left: -18px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
